var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAd = function SvgAd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 6H20c.5 0 .9.3.9.6v11.5c0 .3-.4.6-.9.6H4c-.5 0-.9-.3-.9-.6V6.6c0-.3.4-.6.9-.6zM4 7v10.6h15.8V7.1H4.1zm1.5 1.1H11c.2 0 .5.2.5.5v7.5c0 .3-.3.5-.5.5H5.6a.5.5 0 01-.5-.5V8.6c0-.3.2-.5.5-.5zm7.4 1h4.3c.3 0 .5.3.5.6s-.2.5-.5.5H13a.5.5 0 110-1zm0 2.2h4.3c.3 0 .5.2.5.5s-.2.6-.5.6H13a.5.5 0 01-.5-.5v-.1c0-.3.3-.5.5-.5z"
  })));
};
export default SvgAd;